module.exports = __webpack_public_path__ + "img/arrcouvAll1ere.0f9b75ba.png";